import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { GeometryTypes } from "../../app/types/genericTables.types";

type UseGeometryTypes = {
  geometryList: GeometryTypes[];
  get: (id: GeometryTypes["id"]) => GeometryTypes | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useGeometry = create<UseGeometryTypes>((set, get) => ({
  loading: false,
  geometryList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) =>
    get().geometryList.find((geometryType) => geometryType.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/TiposGeometria";
      const { data: response } = await getData(endpoint);
      set(() => ({
        geometryList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching useGeometry:", error);
      set({ loading: false });
    }
  },
}));
